import styled from "styled-components";
import {media, tokens} from "../../../../../theme";

export const LicenseTimerWrapper = styled.div`
    display: flex;
    flex: none;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    padding: 2rem 5rem;
    background-color: ${({ theme }) => theme.palette.background.dropzone};
    border: 1px solid ${({ theme }) => theme.palette.dividers.light};
    border-radius: ${tokens.radius.lg};

    ${media.lg} {
        flex: 1;
    }
;`